import React from 'react'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import { Form } from 'react-final-form'
import { makeStyles } from '@material-ui/core/styles'
import { Typography } from '@material-ui/core'
import CircularProgress from '@material-ui/core/CircularProgress'

const useStyles = makeStyles(theme => ({
  content: {
    paddingBottom: theme.spacing(3)
  },
  contentWithField: props => ({
    paddingBottom: theme.spacing(3),
    height: props.height || 320
  }),
  btn: {
    width: 160
  }
}))

const ComplexDialog = props => {
  const {
    open,
    handleClose,
    closeActionButtonLabel = 'Cancelar',
    primaryAction,
    primaryActionButtonLabel = 'Confirmar',
    title,
    message,
    footer,
    validate,
    children,
    holdWhileLoading = true,
    fullWidth = false,
    height
  } = props
  const classes = useStyles({ height })
  const handlePrimaryAction = async data => {
    if (holdWhileLoading) {
      await primaryAction(data)
    } else {
      primaryAction(data)
    }
    handleClose()
  }
  const hasContent = Array.isArray(children) && children.some(v => !!v)
  return (
    <div>
      <Dialog open={open} onClose={handleClose} fullWidth={fullWidth}>
        <DialogTitle>{title}</DialogTitle>
        <Form onSubmit={handlePrimaryAction} validate={validate}>
          {({ handleSubmit, submitting }) => (
            <form onSubmit={handleSubmit}>
              {children && (
                <DialogContent
                  className={
                    hasContent ? classes.contentWithField : classes.content
                  }
                >
                  {children}
                </DialogContent>
              )}

              {footer && (
                <DialogContent>
                  <Typography>{footer}</Typography>
                </DialogContent>
              )}
              {message && (
                <DialogContent>
                  <Typography>{message}</Typography>
                </DialogContent>
              )}

              <DialogActions>
                <Button
                  className={classes.btn}
                  onClick={handleClose}
                  variant="outlined"
                  autoFocus
                >
                  {closeActionButtonLabel}
                </Button>
                {primaryAction ? (
                  <Button
                    className={classes.btn}
                    type="submit"
                    disabled={submitting}
                    color="primary"
                    variant="contained"
                    autoFocus
                  >
                    {submitting ? (
                      <CircularProgress size={24} />
                    ) : (
                      primaryActionButtonLabel
                    )}
                  </Button>
                ) : null}
              </DialogActions>
            </form>
          )}
        </Form>
      </Dialog>
    </div>
  )
}

export default ComplexDialog
